import { DummyPartnerIdPrefix } from 'clickNgo/entities/partner/configs'

export const checkIsNewPartner = (partnerId?: string) => {
  if (!partnerId) {
    return true
  }

  return (
    partnerId.startsWith(DummyPartnerIdPrefix.NEW) ||
    partnerId.startsWith(DummyPartnerIdPrefix.PORTAL)
  )
}
